import { trackEvent } from '@patrianna/analytics'
import { cleanDialogStack, replaceDialog } from '@patrianna/dialog-manager'
import { useIsFbBrowser, useMediaQuery } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { useContext } from 'react'

import ROUTES from 'config/routes.json'
import content from 'prismic-translates/loginpage.json'
import AppleAuthButton from 'src/containers/AppleAuthButton'
import FacebookButton from 'src/containers/FacebookButton'
import GoogleAuthButton from 'src/containers/GoogleAuthButton'

import { ManualLoginContext } from '../AuthDialogLayout'
import classes from '../styles.module.scss'

import ManualLogin from './ManualLogin'

const t = getTranslationFromJson([content])

function LoginDialogContent() {
  const matches = useMediaQuery('xs')
  const fbBrowser = useIsFbBrowser()
  const query = useSearchParams().toString()
  const { loginPassed } = useContext(ManualLoginContext)

  const onForgotPassword = () => {
    if (!matches) {
      cleanDialogStack()
    }
    replaceDialog({ dialogName: 'RESET_PASSWORD_DIALOG' })
  }

  return (
    <div className={classes.loginContent}>
      <FacebookButton disabled={loginPassed} authType='LOGIN' text={t('facebookButtonLabel')} />
      <GoogleAuthButton disabled={loginPassed} authType='LOGIN' title={t('googleButtonLabel')} />
      {/* @TODO - need add check on serviceAppleId when will get it with backend  */}
      {!fbBrowser && <AppleAuthButton disabled={loginPassed} title={t('appleButtonLabel')} authType='LOGIN' />}

      <div className={classes.divider}>
        <span className={classes.dividerText}>{t('orLabel')}</span>
      </div>
      <ManualLogin onForgotPassword={onForgotPassword} />

      <span className={classes.accountLink}>
        {t('dontHaveAccount')}
        <Link
          prefetch={false}
          href={{
            pathname: ROUTES.REGISTER,
            query,
          }}
        >
          <span
            className={classes.link}
            data-test='sign-up-link'
            onClick={() => trackEvent('login_page_register_link')}
          >
            {t('signUp')}
          </span>
        </Link>
      </span>
    </div>
  )
}

export default LoginDialogContent
